<template>
  <router-link :class="`border-${message.borderColor}`"
               :to="apiCallDetailLink"
               class="grid grid-cols-5 col-span-5 pt-4 border-solid border-0 border-l-2 pr-3"
               @click.native="selectBubble">
    <api-call-placeholder :focus="isSelected" class="col-span-3 col-start-4"/>
  </router-link>
</template>

<script>
import ApiCallPlaceholder from '@/components/common/ApiCallPlaceholder'

export default {
  name: 'ConversationApiCall',

  components: { ApiCallPlaceholder },

  props: {
    message: {
      type: Object,
      required: true
    },
    selectedBubble: {
      type: Object,
      default: null
    }
  },

  emits: ['bubble-selected'],

  computed: {
    isSelected() {
      return this.selectedBubble && this.selectedBubble.messageId === this.message.id
    },

    apiCallDetailLink() {
      return {
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, messageId: this.message.id, requestId: undefined }
      }
    }
  },

  methods: {
    selectBubble() {
      this.$emit('bubble-selected')
    }
  }
}
</script>
